const translation = {
  tags: {
    image: 'Imagen',
    agent: 'Agente',
    medical: 'Médico',
    weather: 'Tiempo',
    design: 'Diseño',
    videos: 'Vídeos',
    education: 'Educación',
    finance: 'Finanzas',
    entertainment: 'Diversión',
    social: 'Social',
    travel: 'Viajar',
    utilities: 'Utilidades',
    search: 'Buscar',
    news: 'Noticia',
    business: 'Negocio',
    other: 'Otro',
    productivity: 'Productividad',
  },
  allTags: 'Todas las etiquetas',
  searchTags: 'Etiquetas de búsqueda',
}

export default translation
